import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import {
  UpdateProductLine,
  updateProductLine,
} from "#modules/productLines/infra/updateProductLine.api";
import { quoteRequestLineQuery } from "#modules/quoteRequestLines/infra/quoteRequestLine.query";

export const useUpdateProductLine = ({
  quoteRequestLineId,
  options,
}: {
  quoteRequestLineId: string;
  options?: {
    onSuccess?: (productLine: UpdateProductLine) => void;
    onError?: (err: Error) => void;
    onMutate?: () => void;
  };
}) => {
  const queryClient = useQueryClient();
  const { mutate, ...rest } = useMutation({
    mutationFn: updateProductLine,
    onMutate: () => {
      options?.onMutate?.();
    },
    onSuccess: async (productLine: UpdateProductLine) => {
      await queryClient.invalidateQueries(quoteRequestLineQuery({ id: quoteRequestLineId }));

      options?.onSuccess?.(productLine);
    },
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
      options?.onError?.(err);
    },
  });

  return { updateProductLine: mutate, ...rest };
};
